
import HttpClient from "@/services/HttpClient/HttpClient";
import Vue from "vue";

export default Vue.extend({
  name: "ResetPasswordForm",
  data: function () {
    return {
      password: "",
      newPasswordAgain: "",
      formErrors: Array<string>(),
    };
  },
  methods: {
    checkResetForm: function () {
      this.formErrors = [];
      let isValid = true;

      if (!this.password || this.password.trim() === "") {
        isValid = false;
        this.formErrors.push("Le mot de passe est obligatoire.");
      }

      if (!this.newPasswordAgain || this.newPasswordAgain.trim() === "") {
        isValid = false;
        this.formErrors.push("Ressaisir le mot de passe est obligatoire.");
      }

      if (this.newPasswordAgain !== this.password) {
        isValid = false;
        this.formErrors.push("Les mots de passe ne sont pas identiques ");
      }

      return isValid;
    },
    resetPassword: function () {
      if (this.checkResetForm()) {
        const httpClient = new HttpClient();
        httpClient
          .resetPasswordForReal({
            password: this.password,
            token: this.$route.params.token,
          })
          .then(() => {
            window.location.href = "/my-account?reset_password=true";
          })
          .catch((reason) => {
            console.error(reason);
            alert("Une erreur s'est produite.");
          });
      }
    },
  },
});
